<div class="kr-layer-manager" ref="content" kr-detachment-area></div>